<template>
  <div>
    <RequestModal v-if="showRequestModal" v-on:closeModal="showRequestModal = false"/>
    <div class="bgrdimg">
      <Nav />
      <div class="relative stars">
        <img src="../assets/img/about/Group 280.svg" alt="">
      </div>
      <div class="aboutbox px-6 pb-8 lg:px-16">
        <p class="mt-8 text-blue-500 font-light lg:text-lg">News & Insights</p>
        <h1 class="mt-4 text-white font-bold text-2xl lg:w-1/3 lg:text-4xl lg:font-extrabold">Get the latest information on eTranzact</h1>
        <p class="mt-6 text-white font-light lg:w-1/2 lg:text-lg">Here’s a glance at what is happening at eTranzact. Read and download latest information on-the-go</p>
      </div>
    </div>
  <section class="bg-white px-6 py-8 lg:px-16 lg:pb-24 lg:relative">
    <div>
      <p class="text-blue-500 text-2xl font-bold">Annual Reports</p>
      <p class="mt-4 text-gray-500 lg:w-2/5">The financial statements have been prepared in accordance with International Financial Reporting Standards (IFRS).</p>
    </div>
    <p class="font-extrabold text-gray-500 text-sm mt-4 lg:mt-8" >Download reports</p>
    <ul class="mt-4 lg:flex lg:w-2/5 lg:flex-wrap lg:gap-10 lg:items-center">
      <li v-for="report in reports" :key="report.id" class="cursor-pointer">
        <p class="inline text-sm text-gray-500">Year {{report.year}}</p>
        <a target="blank" :href="`${baseURL}/reports/${report.file_name}`" download>
          <font-awesome-icon icon="download" class="inline ml-3 dpblue" />
        </a>
      </li>
    </ul>
    <p class="mt-4 lg:mt-8 text-blue-500 text-2xl font-bold">Explore the Inside eTranzact Magazine</p>
    <p class="font-extrabold text-gray-500 text-sm mt-2 lg:mt-4">Read our magazines</p>
    <a class="block mt-2 text-sm text-blue-500 underline" target="blank" href="https://www.flipsnack.com/etranzact/eenside_etranzact_q12021.html">January-March 2021 edition</a>
    <a class="block mt-2 text-sm text-blue-500 underline" target="blank" href="https://www.flipsnack.com/etranzact/inside-etranzact-june-2021.html">April-June 2021 edition</a>
    <div class="hidden lg:block imgcircle">
      <img src="../assets/img/news/Intersection 47.png" alt="">
    </div>
  </section>
  <section class="px-6 py-8 lg:px-16 lg:py-24 lg:relative highbox" style="background: #062648">
    <div>
      <p class="text-white text-2xl font-semibold">Financial Highlights</p>
      <p class="text-white mt-4 lg:w-2/5">We believe our partners and customers have a right to understand how their data is managed and protected. Report transparency is a key guiding principle in our mission to provide secure and efficient payment services driven by data analytics and consumer insights.</p>
      <div class="mt-6 rounded py-2 px-2 highlights lg:py-4 lg:px-6 lg:rounded-tr-none lg:rounded-br-none" style="background: #E8F2F9"> 
        <ul class="flex justify-between lg:gap-20">
          <li class="">
            <p class="dpblue text-sm font-light lg:font-bold">Turnover</p>
            <p class="mt-2 text-blue-500 text-xl lg:font-bold">N10.405 Bn</p>
          </li>
          <li class="lg:ml-3">
            <p class="dpblue text-sm font-light lg:font-bold">Gross Profit</p>
            <p class="mt-2 text-blue-500 text-xl lg:font-bold">N2.904 Bn</p>
          </li>
          <li class="lg:ml-3">
            <p class="dpblue text-sm font-light lg:font-bold">Profit Before Tax</p>
            <p class="mt-2 text-blue-500 text-xl lg:font-bold">N0.865 Bn</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
  <News />
  <Footer v-on:showRequest="showRequestModal = true" />
</div>
</template>

<script>
import Nav from "@/components/Nav"
import Footer from "@/components/Footer"
import News from "@/components/News"
import RequestModal from "@/components/RequestModal"
import axios from 'axios'
import baseURL from '@/main'

export default {
 components:{
    Nav, 
    Footer, 
    News,
    RequestModal
  },
  data(){
    return {
      showRequestModal : false,
      reports: [],
      baseURL: baseURL
    }
  },
  methods: {
     
  },
  mounted(){
    this.$store.commit('startLoading')
    let vm = this
    axios.get(`${baseURL}/api/reports`)
    .then((res)=>{
      vm.reports = res.data.result
      vm.$store.commit('stopLoading')
    })
    .catch(err=>{
      console.log(err)
      vm.$store.commit('stopLoading')
      alert('Could not load resources')
    })
  }
}
</script>

<style scoped>
/* Modal Styling */
  .l-modal{
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0, 0.3);
  }
  .loading-modal{
    min-height: 350px; 
  }
  .l-modal::-webkit-scrollbar{
    width: 0px;
    background-color: #F5F5F5;
  }
  /* Modal Styling */
.dpblue{
  color: #062648
}
div.bgrdimg{
  background-image: url('../assets/img/about/Intersection 17.svg');
  background-size: cover;
  background-repeat: no-repeat;
}
.stars{
  top: -20px
}

@media only screen and (min-width: 1024px){
  div.aboutbox{
    margin-top: -200px
  }
  .arrowdown{
    cursor: pointer;
    transform: rotateZ(90deg);
  }
  .imgcircle{
    width: 300px;
    height: 300px;
    text-align: center;
    align-content: center;
    align-items: center;
    line-height: 300px;
    border-radius: 50%;
    padding: 20px;
    background-color: #e8f2f9;
    position: absolute;
    right: 80px;
    top: 5%
  }
  .imgcircle img{
    position: relative;
    top: 30px;
    right: 30px
  }
  div.highlights{
    position: absolute;
    right: 0;
    top: 100px;
    
  }
  div.highlights ul{
    justify-content: space-evenly;
  }
  
}
</style>